import React, { useState } from 'react';
import { Button } from '../common';

const styles = {
  nav: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 100,
    padding: '16px 24px',
    transition: 'background-color 0.3s ease',
    backdropFilter: 'blur(12px)',
  },
  content: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  logoIcon: {
    fontSize: '28px',
    color: '#3b82f6',
  },
  logoText: {
    fontSize: '22px',
    fontWeight: '700',
    fontFamily: "'Space Grotesk', sans-serif",
    color: '#fff',
  },
  logoAccent: {
    color: '#3b82f6',
  },
  links: {
    display: 'flex',
    alignItems: 'center',
    gap: '32px',
  },
  link: {
    color: '#94a3b8',
    textDecoration: 'none',
    fontSize: '15px',
    fontWeight: '500',
    transition: 'color 0.2s ease',
  },
  hamburger: {
    display: 'none',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '40px',
    height: '40px',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '8px',
    gap: '5px',
  },
  hamburgerLine: {
    width: '24px',
    height: '2px',
    backgroundColor: '#fff',
    borderRadius: '2px',
    transition: 'all 0.3s ease',
  },
  mobileMenu: {
    position: 'fixed',
    top: '72px',
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(8, 12, 21, 0.98)',
    backdropFilter: 'blur(20px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '32px',
    opacity: 0,
    pointerEvents: 'none',
    transition: 'opacity 0.3s ease',
  },
  mobileMenuOpen: {
    opacity: 1,
    pointerEvents: 'auto',
  },
  mobileLink: {
    color: '#e2e8f0',
    textDecoration: 'none',
    fontSize: '24px',
    fontWeight: '600',
    fontFamily: "'Space Grotesk', sans-serif",
    transition: 'color 0.2s ease',
  },
};

export const Navbar = ({ scrollY = 0 }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navStyle = {
    ...styles.nav,
    backgroundColor: scrollY > 50 || isMenuOpen ? 'rgba(8, 12, 21, 0.95)' : 'transparent',
  };

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <>
      <nav style={navStyle}>
        <div style={styles.content}>
          <div style={styles.logo}>
            <span style={styles.logoIcon}>◈</span>
            <span style={styles.logoText}>
              ClearData<span style={styles.logoAccent}>Ops</span>
            </span>
          </div>

          {/* Desktop Navigation */}
          <div style={styles.links} className="desktop-nav">
            <a href="#diensten" style={styles.link} className="nav-link">Diensten</a>
            <a href="#pakketten" style={styles.link} className="nav-link">Pakketten</a>
            <a href="#proces" style={styles.link} className="nav-link">Werkwijze</a>
            <a href="#faq" style={styles.link} className="nav-link">FAQ</a>
            <Button size="small" href="#contact">
              Intake inplannen →
            </Button>
          </div>

          {/* Mobile Hamburger */}
          <button
            style={styles.hamburger}
            className="mobile-hamburger"
            onClick={toggleMenu}
            aria-label="Menu"
          >
            <span
              style={{
                ...styles.hamburgerLine,
                transform: isMenuOpen ? 'rotate(45deg) translateY(7px)' : 'none',
              }}
            />
            <span
              style={{
                ...styles.hamburgerLine,
                opacity: isMenuOpen ? 0 : 1,
              }}
            />
            <span
              style={{
                ...styles.hamburgerLine,
                transform: isMenuOpen ? 'rotate(-45deg) translateY(-7px)' : 'none',
              }}
            />
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div
        style={{
          ...styles.mobileMenu,
          ...(isMenuOpen ? styles.mobileMenuOpen : {}),
        }}
        className="mobile-menu"
      >
        <a href="#diensten" style={styles.mobileLink} onClick={closeMenu}>Diensten</a>
        <a href="#pakketten" style={styles.mobileLink} onClick={closeMenu}>Pakketten</a>
        <a href="#proces" style={styles.mobileLink} onClick={closeMenu}>Werkwijze</a>
        <a href="#faq" style={styles.mobileLink} onClick={closeMenu}>FAQ</a>
        <Button size="large" href="#contact" onClick={closeMenu}>
          Intake inplannen →
        </Button>
      </div>
    </>
  );
};
